<template>
  <div class="score" :style="`--percentage: ${currentPercentage};`">
    <div class="score__value">
      {{ currentPercentage }}%
    </div>
    <div class="score__spinner">
      <svg width="126" height="126" viewBox="0 0 126 126" fill="none">
        <circle cx="63" cy="63" r="60" stroke-width="6" />
        <circle class="percent" cx="63" cy="63" r="60" stroke-width="6" pathLength="100" />
      </svg>
    </div>
  </div>
</template>

<script>
// @flow

export default {
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      currentPercentage: 0
    }
  },
  mounted () {
    const factor = (0.008 * this.percentage / 100) * 1000
    this.interval = setInterval(() => this.increasePercentage(), factor)
  },
  destroyed () {
    clearInterval(this.interval)
  },
  methods: {
    increasePercentage (): void {
      if (this.currentPercentage >= this.percentage) clearInterval(this.interval)
      else this.currentPercentage += 1
    }
  }
}
</script>

<style src="./score.scss" />
